import { getHref, getTitle } from './meta';

var handleTweet = function handleTweet() {
  var windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes';
  var width = 550;
  var height = 420;
  var winHeight = screen.height;
  var winWidth = screen.width;
  var left = Math.round(winWidth / 2 - width / 2);
  var top = winHeight > height ? Math.round(winHeight / 2 - height / 2) : 0;
  var target = "https://twitter.com/intent/tweet?text=".concat(getTitle(), "&via=Reuters&url=").concat(getHref());
  window.open(target, 'intent', "".concat(windowOptions, ",width=").concat(width, ",height=").concat(height, ",left=").concat(left, ",top=").concat(top));
};

export default handleTweet;